import { AxiosError } from 'axios';

import { AppMessage } from '@/types/appMessage';
import { LoggedOutError } from '@/utils/LoggedOutError';

interface DugoutError {
  [key: string]: string | string[] | Record<string, string | string[]>[] | DugoutError;
}

export const parseErrorData = (errorData: DugoutError): string => {
  return Object.entries(errorData)
    .map((errorEntry) => {
      const [key, error] = errorEntry;

      if (Array.isArray(error)) {
        return error
          .map((e) => {
            if (typeof e === 'string') {
              return `${key}: ${e}`;
            }

            // Use recursion with nested object errors
            // Ex. { tags: [{ id: 'Must be a valid UUID' }, { id: 'Must be a valid UUID' }] }
            return parseErrorData(e);
          })
          .join(', ');
      }

      // Use recursion with nested plain-object errors
      // Ex. { form_schema: { image_2: 'image fields require a non-empty url' } }
      if (error && typeof error === 'object') {
        return parseErrorData(error as DugoutError);
      }

      return error;
    })
    .join(', ');
};

export const errorMessage = (error: AxiosError | string): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error?.response?.data) {
    const { data } = error.response;

    // data may be an HTML doc string
    if (typeof data === 'string') {
      return error.message;
    }

    return parseErrorData(data as DugoutError);
  }

  return error.message;
};

const mapAxiosErrorMessages = (error: AxiosError | string): AppMessage[] => {
  if (error instanceof LoggedOutError) return [];
  return [{ level: 'error', text: errorMessage(error) }];
};

export default mapAxiosErrorMessages;
